import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import FolderOffIcon from '@mui/icons-material/FolderOff';

/**
 * EmptyState component for displaying when no items are found
 */
const EmptyState = ({ icon, title, message, children }) => {
  return (
    <Paper 
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 4,
        height: '100%',
        minHeight: '200px',
        backgroundColor: 'transparent',
        textAlign: 'center'
      }}
    >
      <Box sx={{ color: 'text.secondary', mb: 2 }}>
        {icon || <FolderOffIcon sx={{ fontSize: 60 }} />}
      </Box>
      
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title || 'No Items Found'}
      </Typography>
      
      <Typography variant="body2" color="text.secondary">
        {message || 'There are no items to display in this view.'}
      </Typography>
      
      {children && (
        <Box sx={{ mt: 2 }}>
          {children}
        </Box>
      )}
    </Paper>
  );
};

export default EmptyState;